import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Bubble from './Bubble'
import GoogleStaticMap from 'components/shared/GoogleStaticMap'

const Map = styled(GoogleStaticMap)`
  width: 300px;
  height: 300px;
`

const LocationMessage = ({payload, isLeft, avatar, endOfBlock, createdAt}) => {
  const {
    lat,
    long
  } = payload

  return (
    <Bubble
      isLeft={isLeft}
      avatar={avatar}
      endOfBlock={endOfBlock}
      width='332px'
      timestamp={createdAt}
      stampStyle='map'
    >
      <Map
        latitude={`${lat}`}
        longitude={`${long}`}
        zoom={13}
        size={{ width: 300, height: 300 }}
        scale={2}
        mapType='roadmap'
      />
    </Bubble>
  )
}

export default LocationMessage

LocationMessage.propTypes = {
  avatar: PropTypes.any,
  isLeft: PropTypes.bool,
  payload: PropTypes.object.isRequired,
  endOfBlock: PropTypes.bool,
  createdAt: PropTypes.instanceOf(Date).isRequired
}
